module.exports = __webpack_public_path__ + "img/云存储1.078d535d.jpg";